module.exports = __webpack_public_path__ + "r-v3/img/ico_menu_show_arrow_white.54ad6b56.svg";